import React from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '../context/ThemeContext';
import { Toaster } from 'sonner';
import Sidebar from './Sidebar';

export const AppLayout = () => {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background" data-testid="app-container">
        <Toaster richColors position="bottom-right" />
        <Sidebar />
        <main className="min-h-screen transition-all duration-300 ml-[240px]">
          <div className="p-6 lg:p-8 max-w-[1400px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </ThemeProvider>
  );
};

export default AppLayout;
